import {
  Module,
  VuexModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  USERS_GENERATE,
  USERS_CREATE,
  USERS,
  USERS_SUBAGENT,
  USERS_ACTIVATE,
  RESET_PASSWORD,
  USERS_HISTORY,
  UPDATE_PERMISSION,
  GET_USERS_DOWNLINE,
  UPDATE_COMMISSION,
  GET_PTSUBAGENT,
  CHECK_PREFIX,
  M_POST,
  M_PUT,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'account' })
export default class Account extends VuexModule {
  users: any = {};

  subAccount: any = {};

  history: any = {};

  @Action
  GenerateUser(user: object) {
    return Vue.axios({
      url: BASE_URL + USERS_GENERATE,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  CreateAccount(user) {
    return Vue.axios({
      url: BASE_URL + USERS_CREATE,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Mutation
  mutateDownline(users) {
    this.users = users;
  }

  @Action({ commit: 'mutateDownline' })
  FetchDownLine(user) {
    return Vue.axios({
      url: BASE_URL + USERS,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        const users = data.data;
        if (code === 0) {
          return {
            ...users,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateDownlineSearch(users) {
    this.users = users;
  }

  @Action({ commit: 'mutateDownlineSearch' })
  FetchDownLineSearch(params) {
    return Vue.axios({
      url: BASE_URL + GET_USERS_DOWNLINE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        const users = data.data;
        if (code === 0) {
          return {
            ...users,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateSubAccount(data) {
    this.subAccount = data;
  }

  @Action({ commit: 'mutateSubAccount' })
  FetchSubAccount(user) {
    return Vue.axios({
      url: BASE_URL + USERS_SUBAGENT,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        const { users } = data.data;
        if (code === 0) {
          return users;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  ActiveUser(user) {
    return Vue.axios({
      url: BASE_URL + USERS_ACTIVATE,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  ResetPassword(user) {
    return Vue.axios({
      url: BASE_URL + RESET_PASSWORD,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Mutation
  mutateHistory(data) {
    this.history = data;
  }

  @Action({ commit: 'mutateHistory' })
  FetchHistory(user) {
    return Vue.axios({
      url: BASE_URL + USERS_HISTORY,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdatePermission(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_PERMISSION,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateCommission(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_COMMISSION,
      data: params,
      method: M_PUT,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  CheckPrefix(params) {
    return Vue.axios({
      url: BASE_URL + CHECK_PREFIX,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  FetchPtSubAgent(params = {}) {
    return Vue.axios({
      url: BASE_URL + GET_PTSUBAGENT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
